/** Champs licence/document exclus lors d'une duplication d'inscription (autre parcours). */
export const DUPLICATE_INSCRIPTION_EXCLUDED_FIELD_NOMS = [
    'type_document',
    'cm_document',
    'licence_document',
    'autre_licence_document',
    'numero_pps',
    'pps_document',
    'fis_document',
    'fichier_pass_competition',
    'licence',
    'licence_ffco_document',
    'questionnaire_ffco_document',
    'regles_or_ffco',
    'justificatif_vague_document',
    'justificatif_vague_document_treated',
];

export const DUPLICATE_INSCRIPTION_EXCLUDED_FIELD_SET = new Set(DUPLICATE_INSCRIPTION_EXCLUDED_FIELD_NOMS);
